import {
  ReferralClaimInput,
  ReferralClaimResult,
  ReferralProgramView,
} from "@bbb/model";
import { _apiRequest } from "./_apiClients";

export function getMyReferralProgram(token: string, signal?: AbortSignal) {
  return _apiRequest<ReferralProgramView>("/v1/me/referrals", {
    token,
    signal,
  });
}

export function claimMyReferral(
  token: string,
  payload: ReferralClaimInput,
  signal?: AbortSignal,
) {
  return _apiRequest<ReferralClaimResult>("/v1/me/referrals/claim", {
    method: "POST",
    token,
    data: payload,
    signal,
  });
}
